import React from 'react';

import cypressIds from 'Components/cypress_ids.json';
import { SectionLoader } from 'Components/SectionLoader/SectionLoader';
import { applyCypressData } from 'Utilities/helpers';

import { SimilarVehiclesCarousel } from './SimilarVehiclesCarousel/SimilarVehiclesCarousel';
import { SimilarVehiclesHeader } from './SimilarVehiclesHeader/SimilarVehiclesHeader';
import { useSimilarVehiclesContext } from './SimilarVehiclesProvider/SimilarVehiclesProvider';

import styles from './SimilarVehiclesSection.module.scss';

export const SimilarVehiclesSection: React.FC = () => {
	const { isSimilarVehiclesLoading, similarVehicles } = useSimilarVehiclesContext();

	return (
		<div
			className={styles.container}
			{...applyCypressData(cypressIds.containers.similarVehicleSection)}
			data-testid="similarVehiclesSection"
		>
			{isSimilarVehiclesLoading ? (
				<SectionLoader />
			) : (
				<>
					<SimilarVehiclesHeader />
					<SimilarVehiclesCarousel similarVehicles={similarVehicles} />
				</>
			)}
		</div>
	);
};
